export default __webpack_public_path__ + "static/media/Annotation 2020-11-21 025717.3771df54.png";